export default class GetAllPositionsDTO {
  constructor(public account_id: ID) {}
}
